import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRagObject } from "../../../services/api/instances/storageApi/methods";
import {
  StorageObjectValue,
  StorageScope,
} from "../../../services/api/instances/storageApi/types/service_types";

export const getRagObjectsAction = createAsyncThunk(
  "sidebar/gerRagObjects",
  async ({ text, service }: { text: string; service: StorageScope }) => {
    try {
      return await getRagObject<StorageObjectValue>(text, service);
    } catch (e: unknown) {
      throw new Error(e as string);
    }
  },
);
